<template>
  <!-- 睡眠検査機器配送ｻｰﾋﾞｽ 自宅配送出荷実績シート -->
  <div id="HSTNumberOfShipmentSummary">
    <div id="container">
      <hstNavi v-bind:pageid='"HSTNumberOfShipmentSummary"'></hstNavi>
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 自宅配送出荷実績シート</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>出荷日</th><td><input type="date" id="completionDateStart" v-model="shippingDate" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
          </tr>
        </table>
        <b-button class="searchButton is-primary" @click="doSearch">検索</b-button>
      </div>
      <!-- 検索結果 -->
      <div v-if="hasResult">
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('hstNumberOfShipmentSummaryTable')">クリップボードにコピー</b-button>
        </div>
        <b-table
            id="hstNumberOfShipmentSummaryTable"
            :data="data">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="100" centered >{{props.row.receiptNumber}}</b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100" centered >{{props.row.shippingDate}}</b-table-column>
              <b-table-column field="inspectionKind" label="機種名" width="170" >{{props.row.inspectionKind}}</b-table-column>
              <b-table-column field="serial" label="シリアル" width="130"  >{{props.row.serial}}</b-table-column>
              <b-table-column field="probes" label="プローブ数" width="80" centered >{{props.row.probes}}</b-table-column>
              <b-table-column field="sensor" label="センサー" width="60" centered >{{props.row.sensor}}</b-table-column>
              <b-table-column field="cannula" label="カニューラ数" width="80" centered >{{props.row.cannula}}</b-table-column>
              <b-table-column field="cannulaSize" label="カニューラサイズ" width="100">{{props.row.cannulaSize | getNameFilter(cannulaSizeList)}}</b-table-column>
              <b-table-column field="belt" label="ベルト数" width="80" centered >{{props.row.belt}}</b-table-column>
              <b-table-column field="beltSize" label="ベルトサイズ" width="80">{{props.row.beltSize | getNameFilter(beltSizeList)}}</b-table-column>
              <b-table-column field="tapeSet" label="テープセット数" width="100" centered >1</b-table-column>
              <b-table-column field="questionnaire" label="アンケート用紙" width="100" centered >1</b-table-column>
              <b-table-column field="manual" label="取扱説明書" width="80" centered >1</b-table-column>
              <b-table-column field="InformationStatement" label="案内文" width="80" centered >1</b-table-column>
              <b-table-column field="paymentNumber" label="着払い伝票番号" width="100" centered >{{props.row.paymentNumber}}</b-table-column>
              <b-table-column field="invoiceNumber" label="送り状伝票番号" width="100" centered >{{props.row.invoiceNumber}}</b-table-column>
            </template>
        </b-table>
      </div>

    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/hst/HSTNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "HSTNumberOfShipmentSummary",
  methods: {
    doSearch: function(){
      if(!this.shippingDate){
        this.showErrorMessage("出荷日を指定してください。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHstDeliveryShippingRecordSheetPOST;
      var successCallBack = this.getHstDeliveryShippingRecordSheetPOSTSuccess;
      var errorCallBack = this.getHstDeliveryShippingRecordSheetPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstDeliveryShippingRecordSheetPOST: function(client) {
      return client.apis.internalHst.getHstDeliveryShippingRecordSheetPOST({
        body:{shippingDate:this.shippingDate.replace(/-/g, "/")}
      });
    },
    getHstDeliveryShippingRecordSheetPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHstDeliveryShippingRecordSheetPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  data() {
    let cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, true);
    let beltSizeList = this.getChoiceList(choicesType.beltSize, true);
    return {
      cannulaSizeList,
      beltSizeList,
      shippingDate:"",
      data: {},
      hasResult: false
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return "0"
    }
  },
  components: {
    hstNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.searchButton {
    margin-left:20px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTNumberOfShipmentSummary.vue